// extracted by mini-css-extract-plugin
export default {"msgM":"_90f4be4b80"};